import { Component, Input } from '@angular/core';
import { CentralizerService } from 'src/app/core/services/three-d/centralizer/centralizer.service';

@Component({
  selector: 'app-centralizer',
  templateUrl: './centralizer.component.html',
  styleUrls: ['./centralizer.component.scss'],
})
export class CentralizerComponent {
  @Input() tiny: boolean;
  @Input() objectTitle: string;
  @Input() objectId: number;
  @Input() useIcon = true;
  @Input() buttonText = 'Centralize 3D representation';

  constructor(private centralizerService: CentralizerService) {}

  centralize() {
    this.centralizerService.centralizeSimulationObjectByCredentials(
      this.objectTitle,
      this.objectId,
    );
  }
}
